import Calendar from "@/components/Calendar/index.vue";

export default [
  {
    path: "/ncevents",
    component: {
      render(h) {
        return h("router-view");
      }
    },
    meta: {
      breadcrumbI18n: "navigation:breadcrumbs.NonCompetitionCalendar.title"
    },
    children: [
      {
        path: "",
        name: "NonCompetitionCalendar",
        component: Calendar,
        props: function (route) {
          route.params.showNoncompetitions = true;
          return route.params;
        },
        meta: { ignoreThis: true, keepAlive: true, anchor: "#jumpBreadcrumb" }
      },
      {
        path: "new",
        name: "NoncompetitionEventCreationPage",
        component: () => import("@/components/event/EventForm.vue"),
        props: function (route) {
          route.params.noncompetition = true;
          return route.params;
        },
        meta: {
          breadcrumbI18n: "navigation:breadcrumbs.NewNonCompetition.title",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: ":eventId",
        name: "NoncompetitionEventProfileRoot",
        component: {
          render(h) {
            return h("router-view");
          }
        },
        redirect: { name: "NoncompetitionEventProfilePage" },
        meta: {
          breadcrumb: {
            breadcrumbName: "eventName"
          }
        },
        children: [
          {
            path: "",
            name: "NoncompetitionEventProfilePage",
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            component: () =>
              import("@/components/event/NoncompetitionEventProfilePage.vue"),
            redirect: { name: "NoncompetitionEventSchedule" },
            meta: {
              breadcrumbI18n: "navigation:breadcrumbs.NonCompetitionEvent.title"
            },
            children: [
              {
                path: "",
                name: "NoncompetitionEventSchedule",
                component: () =>
                  import("@/components/event/NoncompetitionEventSchedule.vue"),
                props: true,
                meta: {
                  anchors: {
                    NoncompetitionEventCalendar: "#jumpBreadcrumb",
                    LandingPage: "#jumpBreadcrumb",
                    NoncompetitionEventMap: "#jumpEventPage",
                    default: "#jumpBreadcrumb"
                  }
                }
              }
            ]
          },
          {
            path: "event_product/new",
            name: "NoncompetitionEventProductForm",
            component: () =>
              import("@/components/event/EventProducts/EventProductForm"),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "NoncompetitionEventProductForm",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "event_product/:eventProductId/edit",
            name: "NoncompetitionEventProductFormEdit",
            component: () =>
              import("@/components/event/EventProducts/EventProductForm"),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "NoncompetitionEventProductFormEdit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "dashboard",
            name: "NoncompetitionEventDashboard",
            component: () => import("@/components/event/EventDashboard"),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Dashboard",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "audit_log",
            name: "NoncompetitionEventAuditLog",
            component: () => import("@/components/event/EventAuditLog.vue"),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Audit log",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "edit",
            name: "NoncompetitionEventEditPage",
            component: () => import("@/components/event/EventForm"),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "register",
            name: "NoncompetitionEventRegistrationPage",
            component: () =>
              import(
                "@/components/event/EntryForm/EntryFormStageOne/index.vue"
              ),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Registration",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "registrations/:registrationId/edit",
            name: "NoncompetitionEventRegistrationEditPage",
            component: () =>
              import(
                "@/components/event/EntryForm/EntryFormStageOne/index.vue"
              ),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Registration Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "registrations/:registrantPersonId/success",
            name: "NoncompetitionEntryFormStageThree",
            component: () =>
              import(
                "@/components/event/EntryForm/EntryFormStageThree/index.vue"
              ),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Registration success",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "masterlist_management",
            name: "NoncompetitionEventMasterlistAdminPage",
            component: () =>
              import(
                "@/components/event/NoncompetitionEventMasterlistAdminPage.vue"
              ),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Manage masterlist",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "masterlist_products",
            name: "NoncompetitionEventMasterlistProductsPage",
            component: () =>
              import(
                "@/components/event/masterlist_products/EventMasterlistProductsPage.vue"
              ),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Manage products",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "finances",
            name: "NoncompetitionEventFinancesPage",
            component: () => import("@/components/event/finance/EventFinances"),
            props: function (route) {
              route.params.noncompetition = true;
              return route.params;
            },
            meta: {
              breadcrumb: "Finances",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          }
        ]
      }
    ]
  },
  {
    path: "/events",
    component: {
      render(h) {
        return h("router-view");
      }
    },
    meta: { breadcrumbI18n: "navigation:breadcrumbs.Calendar.title" },
    children: [
      {
        path: "",
        name: "Calendar",
        component: Calendar,
        props: true,
        meta: { ignoreThis: true, keepAlive: true, anchor: "#jumpBreadcrumb" }
      },
      {
        path: "new",
        name: "EventCreationPage",
        component: () => import("@/components/event/EventForm.vue"),
        props: true,
        meta: {
          breadcrumbI18n: "navigation:breadcrumbs.NewEvent.title",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: ":eventId",
        name: "EventRoot",
        props: true,
        component: {
          render(h) {
            return h("router-view");
          }
        },
        meta: {
          breadcrumb: {
            breadcrumbName: "eventName"
          }
        },
        redirect: { name: "EventProfilePage" },
        children: [
          {
            path: "",
            name: "EventProfilePage",
            component: () => import("@/components/event/EventProfilePage.vue"),
            props: true,
            redirect: { name: "EventSchedule" },
            meta: {
              breadcrumbI18n: "navigation:breadcrumbs.EventProfilePage.title"
            },
            children: [
              {
                path: "",
                name: "EventSchedule",
                component: () =>
                  import("@/components/event/EventSchedule/EventSchedule.vue"),
                props: true,
                meta: {
                  anchors: {
                    Calendar: "#jumpBreadcrumb",
                    LandingPage: "#jumpBreadcrumb",
                    EventMap: "#eventSchedule",
                    EventResultsPage: "#eventSchedule",
                    CompetitionEditPage: "#eventSchedule",
                    default: "#jumpBreadcrumb"
                  }
                }
              },
              {
                path: "map",
                name: "EventMap",
                component: () => import("@/components/event/EventMap.vue"),
                props: true,
                meta: { anchor: "#jumpEventPage" }
              },

              {
                path: "results",
                component: {
                  render(h) {
                    return h("router-view");
                  }
                },
                props: true,

                children: [
                  {
                    path: "",
                    name: "EventResultsPage",
                    props: true,
                    component: () =>
                      import(
                        "@/components/event/EventResults/EventResultsPage/index.vue"
                      ),
                    meta: {
                      anchor: "#jumpEventPage"
                    }
                  }
                ]
              }
            ]
          },
          {
            path: "event_product/new",
            name: "EventProductForm",
            component: () =>
              import("@/components/event/EventProducts/EventProductForm"),
            props: true,
            meta: {
              breadcrumb: "EventProductForm",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "event_product/:eventProductId/edit",
            name: "EventProductFormEdit",
            component: () =>
              import("@/components/event/EventProducts/EventProductForm"),
            props: true,
            meta: {
              breadcrumb: "EventProductFormEdit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "dashboard",
            name: "EventDashboard",
            component: () => import("@/components/event/EventDashboard"),
            props: true,
            meta: {
              breadcrumb: "Dashboard",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "audit_log",
            name: "EventAuditLog",
            component: () => import("@/components/event/EventAuditLog"),
            props: true,
            meta: {
              breadcrumb: "Audit log",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "register",
            name: "EventRegistrationPage",
            component: () =>
              import("@/components/event/EntryForm/EntryFormStageOne"),
            props: true,
            meta: {
              breadcrumb: "Registration",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "register_multi",
            name: "EventMultiRegistrationPage",
            component: () =>
              import(
                "@/components/event/EntryForm/EntryFormMultiple/EntryFormMultiple.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Registration",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "register_multi_response",
            name: "EventMultiRegistrationResponsePage",
            component: () =>
              import(
                "@/components/event/EntryForm/EntryFormMultiple/EntryFormMultipleResponse.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Registration",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "registrations/:registrationId/edit",
            name: "EventRegistrationEditPage",
            component: () =>
              import("@/components/event/EntryForm/EntryFormStageOne"),
            props: true,
            meta: {
              breadcrumb: "Registration Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "registrations/:registrantPersonId/success",
            name: "EntryFormStageThree",
            component: () =>
              import("@/components/event/EntryForm/EntryFormStageThree"),
            props: true,
            meta: {
              breadcrumb: "Registration success",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "edit",
            name: "EventEditPage",
            component: () => import("@/components/event/EventForm"),
            props: true,
            meta: {
              breadcrumb: "Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "finances",
            name: "EventFinancesPage",
            component: () => import("@/components/event/finance/EventFinances"),
            props: true,
            meta: {
              breadcrumb: "Finances",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "masterlist_management",
            name: "EventMasterlistAdminPage",
            component: () =>
              import(
                "@/components/event/masterlist_new/EventMasterlistAdminPage.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Manage masterlist",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "masterlist_management_legacy",
            name: "EventMasterlistAdminPageLegacy",
            component: () =>
              import("@/components/event/EventMasterlistAdminPage.vue"),
            props: true,
            meta: {
              breadcrumb: "Manage masterlist",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "masterlist_products",
            name: "EventMasterlistProductsPage",
            component: () =>
              import(
                "@/components/event/masterlist_products/EventMasterlistProductsPage.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Manage products",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "competitions/new",
            name: "CompetitionEventCreationPage",
            component: () =>
              import("@/components/event/competition/CompetitionForm"),
            props: true,
            meta: {
              breadcrumb: "New Competition",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "competitions/:competitionId/edit",
            name: "CompetitionEditPage",
            component: () =>
              import("@/components/event/competition/CompetitionForm"),
            props: true,
            meta: {
              breadcrumb: "Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "competitions_management",
            name: "CompetitionManagementForm",
            component: () =>
              import(
                "@/components/event/competition/CompetitionManagementForm.vue"
              ),
            props: true,
            meta: {
              breadcrumb: "Edit classes",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "competitions/:competitionId/new_rules",
            name: "CompetitionRulesFormNew",
            component: () =>
              import(
                "@/components/event/competition/CompetitionEntryRulesForm.vue"
              ),
            props: true,
            meta: {
              breadcrumbI18n: "navigations:breadcrumbs.entryRules.title",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "competitions/:competitionId/edit_rules/:competitionEntryRuleId",
            name: "CompetitionRulesFormEdit",
            component: () =>
              import(
                "@/components/event/competition/CompetitionEntryRulesForm.vue"
              ),
            props: true,
            meta: {
              breadcrumbI18n: "navigations:breadcrumbs.entryRules.title",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          },
          {
            path: "statistics",
            name: "EventSurveyStatsRoot",
            component: () =>
              import(
                "@/components/event/EventSurveyStats/EventSurveyStatsRoot"
              ),
            props: true,
            redirect: { name: "EventSurveyStats" },
            meta: {
              breadcrumb: "navigation:breadcrumbs.statisticsAndReports.title",
              anchor: "#jumpBreadcrumb",
              requireAuthorize: true
            },
            children: [
              {
                path: "",
                name: "EventSurveyStats",
                component: () => import("@/components/event/EventSurveyStats"),
                props: true,
                meta: {
                  requireAuthorize: true,
                  anchor: "#jumpBreadcrumb"
                }
              },
              {
                path: "survey/:surveyId",
                name: "SurveyForm",
                component: () => import("@/components/surveys/SurveyForm"),
                props: true,
                meta: {
                  breadcrumb: { breadcrumbName: "surveyName" },
                  anchor: "#jumpBreadcrumb",
                  requireAuthorize: true
                }
              },
              {
                path: "survey/:surveyId/edit/:surveyResponseId",
                name: "SurveyFormEdit",
                component: () => import("@/components/surveys/SurveyForm"),
                props: true,
                meta: {
                  breadcrumb: { breadcrumbName: "surveyName" },
                  anchor: "#jumpBreadcrumb",
                  requireAuthorize: true
                }
              }
            ]
          }
        ]
      }
    ]
  }
];
